import React, { FunctionComponent, ReactNode } from "react";

import { bemClassNames, CUSTOM_CSS_PROPERTY_PREFIX, transformKeysToParamCase } from "@multiweb/reactUtils";

/**
 * Počet sloupců (min: 1, max: 12)
 * */
export enum GridColumnCount {
    one = 1,
    two,
    three,
    four,
    five,
    six,
    seven,
    eight,
    nine,
    ten,
    eleven,
    twelve,
}

/**
 * Velikost mezery (min: 1, max: 8)
 * */
export enum GridGapSize {
    one = 1,
    two,
    three,
    four,
    five,
    six,
    seven,
    eight,
}

/** Vertikální zarovnání položek*/
export enum GridLayoutAlignItems {
    start = "start",
    end = "end",
    center = "center",
    stretch = "stretch",
}

/** Vertikální zarovnání položek*/
export enum GridLayoutJustifyItems {
    start = "start",
    end = "end",
    center = "center",
    stretch = "stretch",
}

export type GridLayoutProps = {
    /** Potomci k vyrenderování */
    children?: ReactNode;
    /** Šířka layoutu v pixelech */
    width?: string;
    /** Výška layoutu v pixelech */
    height?: number | string;
    /** Zarovnání horizontální */
    alignItems?: GridLayoutAlignItems;
    /** Zarovnání vertikální */
    justifyItems?: GridLayoutJustifyItems;
    /** Přeskládá položky gridu tak, aby došlo k odstranění přebytečných mezer */
    dense?: boolean;
    /** Počet sloupců. Ve výchozím stavu je komponenta rozdělena na 12 sloupců. */
    columns?: GridColumnCount;
    /** Počet sloupců pro šířku obrazovky S */
    columnsS?: GridColumnCount;
    /** Počet sloupců pro šířku obrazovky M */
    columnsM?: GridColumnCount;
    /** Počet sloupců pro šířku obrazovky L */
    columnsL?: GridColumnCount;
    /** Počet sloupců pro šířku obrazovky XL */
    columnsXl?: GridColumnCount;
    /** Počet sloupců pro šířku obrazovky XXL */
    columnsXxl?: GridColumnCount;
    /** Velikost mezery */
    gap?: GridGapSize;
    /** Velikost mezery S */
    gapS?: GridGapSize;
    /** Velikost mezery M */
    gapM?: GridGapSize;
    /** Velikost mezery L */
    gapL?: GridGapSize;
    /** Velikost mezery XL */
    gapXl?: GridGapSize;
    /** Velikost mezery XXL */
    gapXxl?: GridGapSize;
};

const classNames = bemClassNames("grid-layout-component");

/** Komponenta umožňující grid rozložení */
export const GridLayout: FunctionComponent<GridLayoutProps> = ({
    children,
    width,
    height,
    alignItems,
    justifyItems,
    dense,
    columns,
    columnsS,
    columnsM,
    columnsL,
    columnsXl,
    columnsXxl,
    gap,
    gapS,
    gapM,
    gapL,
    gapXl,
    gapXxl,
}) => (
    <div
        className={classNames(
            transformKeysToParamCase({
                alignItems,
                justifyItems,
                dense,
            }),
        )}
        style={{
            ...transformKeysToParamCase({
                columns,
                columnsS,
                columnsM,
                columnsL,
                columnsXl,
                columnsXxl,
                gap,
                gapS,
                gapM,
                gapL,
                gapXl,
                gapXxl,
            }, CUSTOM_CSS_PROPERTY_PREFIX),
            width,
            height,
        }}
    >
        {children}
    </div>
);
